export const createOptions = arr => {
  return arr.map(item => ({
    text: item.name,
    value: item._id,
    key: item._id
  }));
};
